import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../store/state';
import { AuthResponse, UserType } from '../api/types';
import { ac } from 'react-router/dist/development/route-data-aSUFWnQ6';

type AuthState = {
  token: string | null;
  user: UserType | null;
};

export const initialState: AuthState = {
  token: null,
  user: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthResponse: (state, action: PayloadAction<AuthResponse>) => {
      state.token = action.payload.access;
      state.user = action.payload.user;
      localStorage.setItem('authInfo', JSON.stringify(action.payload));
    },
    setNewToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      const authInfo = localStorage.getItem('authInfo');
      if (authInfo) {
        const data = JSON.parse(authInfo);
        const newAuthInfo = { ...data, access: action.payload };
        localStorage.setItem('authInfo', JSON.stringify(newAuthInfo));
      }
    },
    clearAuthResponse: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem('authInfo');
    }
  }
});

// Actions generated from the slice
export const { clearAuthResponse, setAuthResponse, setNewToken } = authSlice.actions;

// export user selector to get the slice in any component
export const authSelector = (state: RootState) => state.auth;
// export The reducer
const authReducer = authSlice.reducer;
export default authReducer;
